import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EstadoCuentaComponent } from '../estado-cuenta-detalle/estado-cuenta.component';
import { CuentaService, ParametrizacionService } from 'src/app/open-api';
import { NgxSpinnerService } from 'ngx-spinner';
import { ObtenerEstadoCuentaME } from 'src/app/open-api/model/obtenerEstadoCuentaME';
import { EMPTY_STRING, nowDate } from 'src/app/shared/utils/regular-expresions';
import { ObtenerEstadoCuentaMS } from 'src/app/open-api/model/obtenerEstadoCuentaMS';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { UserModel } from '../../models/user.model';
import { AuthService } from '../../services/auth.service';
import * as XLSX from 'xlsx';
import { formatDate } from 'src/app/shared/utils/cedula-ecuador.validators';

@Component({
  selector: 'app-estado-cuenta-rango',
  templateUrl: './estado-cuenta-rango.component.html',
  styleUrls: ['./estado-cuenta-rango.component.scss'],
})
export class EstadoCuentaRangoComponent implements OnInit {
  @Input() set SecuencialCuenta(secuencial: number) {
    this.secuencialCuenta = secuencial;
  };
  secuencialCuenta?: number;
  hoy = new Date();
  fechaInicio = new Date(this.hoy.setDate(this.hoy.getDate() - 7));
  fechaFin = new Date();
  minFechaInicio = new Date(); 
  mesesRango = 0;
  estadoCuenta?:ObtenerEstadoCuentaMS;
  currentDate=''
  mostrarEstadoCuenta=false;
  usuario?: UserModel;

  constructor(private modalService: NgbModal
    ,private parametrizacion :ParametrizacionService,
    private spinner: NgxSpinnerService,
    private cuentaService:CuentaService,
    private authService: AuthService,
    ) {}


    ngOnChanges(changes: SimpleChanges): void {
      if (changes.SecuencialCuenta) this.ngOnInit();
    }

  async ngOnInit() {

    await this.obtenerParametrizacion()
    this.authService.user.subscribe((usuario) => {
      this.usuario = usuario;
    });
    this.currentDate = new Date().toString();

  }

  AbrirModal(): void {
    const modalRef = this.modalService.open(EstadoCuentaComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.secuencialCuenta = this.secuencialCuenta;
    modalRef.componentInstance.fechaInicio = this.minFechaInicio;
    modalRef.componentInstance.fechaFin = this.fechaFin;
  }


  async obtenerParametrizacion(){
    this.spinner.show();
    this.parametrizacion.apiV10ParametrizacionObtenerParametrizacionOperacionesPost().subscribe(item => {
        this.mesesRango = Number(item.operaciones?.find(g => g.id == 1)?.valor ?? 0);
      
        const ahora = new Date();
        this.minFechaInicio = new Date(ahora.getFullYear(), ahora.getMonth() - this.mesesRango, ahora.getDate());
       
        this.spinner.hide();
      
    }, error => {
        this.spinner.hide();
    });
}

ObtenerInformacion(): void {
  this.spinner.show();
  
  const parametro: ObtenerEstadoCuentaME = {
    secuencialCuenta: this.secuencialCuenta ?? 0,
    fechaInicio: this.fechaInicio,
    fechaFin: this.fechaFin
  };

  this.mostrarEstadoCuenta = true;

  this.cuentaService.apiV10CuentaObtenerEstadoCuentaPorSecuencialPost(parametro)
    .subscribe({
      next: (respuesta) => {
        this.estadoCuenta = respuesta;
        setTimeout(() => {
          this.Descargar();
        }, 100);
      },
      error: (err) => {
        this.mostrarEstadoCuenta = false;
        this.spinner.hide(); 
      },
      complete: () => {
        this.spinner.hide(); 
      }
    });
}

ObtenerInformacionForExcel(): void {
  this.spinner.show();
  
  const parametro: ObtenerEstadoCuentaME = {
    secuencialCuenta: this.secuencialCuenta ?? 0,
    fechaInicio: this.fechaInicio,
    fechaFin: this.fechaFin
  };

  this.mostrarEstadoCuenta = true;

  this.cuentaService.apiV10CuentaObtenerEstadoCuentaPorSecuencialPost(parametro)
    .subscribe({
      next: (respuesta) => {
        this.estadoCuenta = respuesta;
        setTimeout(() => {
          this.exportarExcel();
        }, 100);
      },
      error: (err) => {
        this.mostrarEstadoCuenta = false;
        this.spinner.hide(); 
      },
      complete: () => {
        this.spinner.hide(); 
      }
    });
}

Descargar(): void {
  this.spinner.show();
  const titlePage = 'Canal Web - Riobamba ---- Estado de Cuenta';
  const doc = new jsPDF('p', 'mm', 'a4');
  const htmlDoc = document.getElementById('cuerpo');

  doc.html(htmlDoc?.innerHTML || '', {
    callback: (doc) => {
      const pageCount = doc.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        const footerContent = `Usuario: ${this.usuario?.nombreUsuario} - Fecha ${nowDate()} - Canal: Web-Transaccional `;
        doc.text(footerContent, 70, doc.internal.pageSize.height - 10);
      }
      doc.save(`${titlePage}.pdf`);
      this.spinner.hide();
      this.mostrarEstadoCuenta = false;
    },
    width: 170,
    windowWidth: 700,
    autoPaging: true,
    x: 10,
    y: 10,
    margin: [10, 0, 20, 0],
  });
}


exportarExcel(): void {
  this.spinner.show();
  const hojaDeCalculo: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([
    ['', '', 'COOPERATIVA DE AHORRO Y CRÉDITO RIOBAMBA LTDA'],
    ['', '', 'RUC: 0690045389001'],
    ['', '', 'ESTADO DE CUENTA'],
    ['', '', `Consulta de movimientos de cuenta del ${formatDate(this.fechaInicio)} a ${formatDate(this.fechaFin)}`],
    [], 
    ['Nombre del Cliente:',this.estadoCuenta?.cabeceraEstadoCuenta?.nombreCliente ?? '-','', 'CI:', this.estadoCuenta?.cabeceraEstadoCuenta?.cedula || '-' ],
    ['Nombre de la Cuenta:',this.estadoCuenta?.cabeceraEstadoCuenta?.nombreCuenta ?? '-','', 'Producto:', this.estadoCuenta?.cabeceraEstadoCuenta?.producto || '-' ],
    ['Código de Cliente:',this.estadoCuenta?.cabeceraEstadoCuenta?.numeroCliente ?? '-','', 'Fecha Apertura:', this.estadoCuenta?.cabeceraEstadoCuenta?.fechaApertura || '-' ],
    ['No. de Cuenta:',this.estadoCuenta?.cabeceraEstadoCuenta?.cuenta ?? '-','', 'Fecha Emisión:', nowDate() || '-' ]
  ]);


  const tabla = document.querySelector('.detalle') as HTMLTableElement;
  XLSX.utils.sheet_add_dom(hojaDeCalculo, tabla, { origin: 'A12' });


  const libro: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(libro, hojaDeCalculo, 'Estado de Cuenta');
  this.spinner.hide();
  this.mostrarEstadoCuenta = false;

  XLSX.writeFile(libro, 'EstadoDeCuenta.xlsx');
}






}